import {isFeatureEnabled} from '@github-ui/feature-flags'
import {clearLocalStorage} from '@github-ui/use-safe-storage/local-storage'

export const REPO_GROUP_COLLAPSED_STORAGE_KEY_PREFIX = 'copilot-agents-sidebar-repo-group-collapsed:'

/** Key marking a repository group as collapsed. Expanded groups have no entry. */
export function repoGroupCollapsedStorageKey(groupKey: string): string {
  return `${REPO_GROUP_COLLAPSED_STORAGE_KEY_PREFIX}${groupKey}`
}

/**
 * Expands a repository group in the Agents sidebar so a task just created for
 * that repo is visible. No-op when the flag is off, since the sidebar then uses
 * in-memory state that already defaults to expanded.
 */
export function expandRepoGroupInSidebar(groupKey: string): void {
  if (!isFeatureEnabled('copilot_mission_control_agents_task_detail')) return
  clearLocalStorage([repoGroupCollapsedStorageKey(groupKey)])
}
